import { HBL_PA_RESOURCES } from "../constants/data.cnst";
import { DEFAULT_ROUTE_PRIORITY } from "../constants/defaultRoutes";
import { authStore } from "./authStore";

// const BASE_URL = import.meta.env.VITE_API_BASE_URL;
const BASE_URL = 'https://dev.hbl-pa.vassardigital.ai/um';

class PermissionService {

  private permissionsLoaded = false;

  async getToken(): Promise<string | null> {
    return authStore.getFreshToken();
  }

  async generateCsrf(token: string) {
    const res = await fetch(`${BASE_URL}/generate-csrf-token`, {
      headers: {
        keycloakauthorization: `Bearer ${token}`
      }
    });

    return res.json();
  }

  getDefaultAccessibleRoute(): string | null {

    const permissions = JSON.parse(
      localStorage.getItem("userPermissions") || "{}"
    );

    const resources =
      permissions?.[HBL_PA_RESOURCES.HBL_PA]?.resources || {};

    const route = DEFAULT_ROUTE_PRIORITY.find(r => resources[r.resource]);

    return route?.path ?? null;
  }

  async getUserPermissions(userId: string, token: string) {
    const csrfToken = localStorage.getItem("csrfToken") || "";

    const res = await fetch(`${BASE_URL}/user-permissions/${userId}`, {
      headers: {
        keycloakauthorization: `Bearer ${token}`,
        "csrf-token": csrfToken
      }
    });

    return res.json();
  }

  async initPermissions() {

    if (this.permissionsLoaded) return;

    const token = await this.getToken();

    if (!token) return;

    if (!localStorage.getItem("csrfToken")) {

      const csrfRes = await this.generateCsrf(token);

      localStorage.setItem(
        "csrfToken",
        csrfRes.response.tokens.csrf
      );

      const { userDetails } = csrfRes.response;

      localStorage.setItem(
        "userInfo",
        JSON.stringify(userDetails)
      );
    }

    const payload = JSON.parse(atob(token.split(".")[1]));
    const userId = payload.sub;

    const permRes = await this.getUserPermissions(userId, token);

    const permissions = permRes.response.permissions;
    const metaInfo = permRes.response?.meta ?? {};

    localStorage.setItem(
      "userPermissions",
      JSON.stringify(permissions)
    );
    window.dispatchEvent(new Event("userPermissionsLoaded"));

    localStorage.setItem(
      "metaInfo",
      JSON.stringify(metaInfo)
    );

    this.permissionsLoaded = true;
  }

  checkAccess(resource: string): boolean {

    const permissions = JSON.parse(
      localStorage.getItem("userPermissions") || "null"
    );

    if (!resource) return true;

    return !!permissions?.[HBL_PA_RESOURCES.HBL_PA]?.resources?.[resource];
  }
}

export const permissionService = new PermissionService();